import { ConnectedEntity } from "src/types/apps";

import SkeletonForm from "../Products/ConnectAccount/ConnectStep/components/SkeletonForm";
import Context, { CustomConnectProps } from "./context";
import DynamicFormWrapper from "./DynamicFormWrapper";
import useGetEntityLoginParams from "./services/useGetEntityLoginParams";
import DynamicFormUpdate from "./Update/DynamicFormUpdate";

// ----------------------------------------------------------------------

type Props = {
	customConnectProps?: CustomConnectProps;
	entity?: ConnectedEntity;
	id: string;
	product?: string;
};

export const ConnectDynamicForm = ({ customConnectProps, entity, id, product }: Props) => {
	const isUpdate = !!customConnectProps?.updateToken;
	const isReset = !!customConnectProps?.restoreToken;
	const hasCredentials = entity && entity?.hasCredentials;
	const isBlocked = entity && entity?.blocked;

	const { selectedValue, onChangeValue, params, isLoading } = useGetEntityLoginParams({
		id,
		entity: entity?.id ?? "",
		isDemo: !!product,
		isUpdateFlow: isUpdate || isReset
	});

	if (isLoading && !isUpdate) return <SkeletonForm />;

	let content = <DynamicFormWrapper />;

	if ((isUpdate && hasCredentials) || (isReset && isBlocked)) content = <DynamicFormUpdate />;

	return (
		<Context.Provider
			value={{
				customConnectProps,
				entity,
				params,
				id,
				product,
				selectedValue,
				onChangeValue
			}}
		>
			{content}
		</Context.Provider>
	);
};

export default ConnectDynamicForm;
